import { render, staticRenderFns } from "./ListStop.vue?vue&type=template&id=88b84bd2&"
import script from "./ListStop.vue?vue&type=script&lang=js&"
export * from "./ListStop.vue?vue&type=script&lang=js&"
import style0 from "./ListStop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports